import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a711e28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewer-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("mdi-arrow-split-vertical")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("split viewers")

import { ref, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Map from '@/components/Map.vue';
import Equirectangular from '@/components/Equirectangular.vue';
import PointCloud from '@/components/PointCloud.vue';
import Merged from '@/components/Merged.vue';
import config from '@/config';
import { XYZ, LonLatZ } from '@/models/geometry';
import { PointCloudData } from '@/models/point-cloud';
import { computeCartesianCentroidFromGeographicPoints, computeCartesianlPointCloudTranslationForLocalReferenceSystem } from '@/helpers/geometry';
import { EnumActionTypes } from '@/store/modules/geometry';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const store = useStore();

const timestampLastResized = ref(0);
const isLoading = ref(true);
const isViewersMerged = ref(false);

const computeReferenceData = (): void => {
  console.log('compute reference data!!');
  const { pointClouds } = config;
  let references = [] as LonLatZ[];

  const pointCloudReferenceFileUrls = pointClouds
    .map((x) => (x.directory.startsWith('http://') || x.directory.startsWith('https://')
      ? `${x.directory}/reference.csv`
      : `data/point-cloud/${x.directory}/reference.csv`));

  const pointCloudReferencePromises = pointCloudReferenceFileUrls
    .map(async (x, i) => (pointClouds[i].referenceOverride || (await fetch(x)).text()));

  Promise.all(pointCloudReferencePromises)
    .then((referenceFiles) => {
      references = referenceFiles.map((x) => x.trim().split(',').map((y) => parseFloat(y))) as LonLatZ[];
      return computeCartesianCentroidFromGeographicPoints(references, config.cartesianSystemProjectionString);
    })
    .then((referenceGlobal) => ([referenceGlobal, references.map((x, i) => ({
      directory: pointClouds[i].directory.startsWith('http://') || pointClouds[i].directory.startsWith('https://')
        ? pointClouds[i].directory
        : `data/point-cloud/${pointClouds[i].directory}`,
      translateForLocalReferenceSystem: computeCartesianlPointCloudTranslationForLocalReferenceSystem(x, referenceGlobal, config.cartesianSystemProjectionString),
    })) as PointCloudData[]] as [XYZ, PointCloudData[]]))
    .then(([referenceGlobal, pointCloudData]) => (
      Promise.all([
        store.dispatch(`geometry/${EnumActionTypes.SET_REFERENCE_GLOBAL}`, referenceGlobal),
        store.dispatch(`geometry/${EnumActionTypes.SET_POINTCLOUD_DATA}`, pointCloudData),
      ])
    ))
    .then(() => {
      isLoading.value = false;
    });
};

const onResize = () => {
  timestampLastResized.value = Date.now();
};

onBeforeMount(() => {
  computeReferenceData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, { key: 0 }))
      : (_openBlock(), _createBlock(_unref(Splitpanes), {
          key: 1,
          horizontal: "",
          class: "default-theme",
          onResize: onResize
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Pane), null, {
              default: _withCtx(() => [
                (isViewersMerged.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Merged, { timestampLastResized: timestampLastResized.value }, null, 8, ["timestampLastResized"]),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "btn-split",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isViewersMerged.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "start"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createBlock(Equirectangular, {
                      key: 1,
                      timestampLastResized: timestampLastResized.value
                    }, null, 8, ["timestampLastResized"]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Pane), { size: "40" }, {
              default: _withCtx(() => [
                _createVNode(Map, { timestampLastResized: timestampLastResized.value }, null, 8, ["timestampLastResized"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}
}

})